export const ASSET_TYPES = {
  TEXTURE: 'texture',
  GLTF: 'gltf',
  BASIS_TEXTURE: 'basis'
  //HDR: 'hdr',
}
